function CHUkBodyHowitWorks() {
  return (
    <>
      <div className="container-fluid p-4 body-font">
        <div className="row">
          <div className="col-xs-12 col-md-6 py-md-5">
            <p className="h6">
              <b>How it works</b>
            </p>
            <p className="h1">
              <i>
                <b>Getting started with Hertz 24/7</b>
              </i>
            </p>
            <p className="h6">
              Using Hertz 24/7® is simple. Just create your membership profile
              and gain access to all Hertz 24/7® vehicles available through our
              various partners across Europe.
            </p>
            <p className="h6">
              All you need is our free Hertz 24/7® app. Enter your details once,
              upload your documents for verification, and you're ready to go!
            </p>
          </div>
          <div className="col-xs-12 col-md-6" style={{ textAlign: "right" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/howitworks-top.png"
              alt=""
            />
          </div>
        </div>

        <div className="row" style={{ backgroundColor: "#F3F3F3" }}>
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <br />
            <h1 className="display-5">
              <b>How Hertz 24/7® works</b>
            </h1>
            <br />
            <p className="h6">
              We’ve made renting with Hertz 24/7® so simple and fast that you
              can be in your vehicle within 15 minutes. Here’s how it works.
            </p>
            <br />
          </div>
        </div>

        <div className="row" style={{ backgroundColor: "#F3F3F3" }}>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/QR_large.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>01</b>
            </p>
            <br />
            <p className="h2">Download the app</p>
            <p>
              You can quickly and easily download the Hertz 24/7 app from your
              app store by scanning the QR code.
            </p>
          </div>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "center" }}>
            <img
              style={{ width: "240px", borderRadius: "15px" }}
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/de-de/static/247_DL_CH.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>02</b>
            </p>
            <br />
            <p className="h2">Registration</p>
            <p>
              Simply create your membership profile and submit your documents
              for verification using the in-app photo function.
            </p>
          </div>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "center" }}>
            <img
              style={{
                width: "260px",
                borderRadius: "15px",
                border: "1px solid #ccc",
              }}
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Select_Location_CH.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>03</b>
            </p>
            <br />
            <p className="h2">Book your vehicle</p>
            <p>
              Log in to the app and book your vehicle by selecting your desired
              location and pick-up time. You will need a credit/debit card or a
              PayPal account.
            </p>
          </div>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Step4-Start.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>04</b>
            </p>
            <br />
            <p className="h2">Start your rental</p>
            <p>
              Shortly before your rental begins, a vehicle will be assigned to
              you. At pick-up, you will receive the digital key in the app to
              unlock the vehicle.
            </p>
          </div>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Step5-During.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>05</b>
            </p>
            <br />
            <p className="h2">During your rental</p>
            <p>
              If you need more time during your rental, you can extend your
              booking. You can also view your rental details at any time. In
              case of inactivity, the immobiliser may be activated. Use the
              power button in the app to deactivate it.
            </p>
          </div>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Step6-End.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>06</b>
            </p>
            <br />
            <p className="h2">End your rental</p>
            <p>
              When you’re finished, complete the rental by going through the
              end-of-rental check and checklist. Your invoice will be sent to
              you by email within 48 hours and the deposit will be released.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <br />
            <h1 className="display-5">
              <b>FAQs</b>
            </h1>
            <p className="h6"></p>
          </div>

          <div className="col-xs-12" style={{ textAlign: "left" }}>
            <br />
            <br />

            <div className="accordion p-4" id="accordionFlushExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading1">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse1"
                    aria-expanded="false"
                    aria-controls="flush-collapse1"
                  >
                    <b>What is Hertz 24/7?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse1"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading1"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      Hertz 24/7® is Hertz’s car-sharing product that gives you
                      the convenience and flexibility to access a wide range of
                      vans and vehicles. You can rent by the hour or by the day.
                      Pick-up is available 24/7 (depending on the opening hours
                      of the specific location). With Hertz 24/7, you can easily
                      book and manage your rental through the 24/7 app. Our goal
                      is for you to be ready to drive within 15 minutes of
                      downloading the app.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading2">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse2"
                    aria-expanded="false"
                    aria-controls="flush-collapse2"
                  >
                    <b>What do I need to use Hertz 24/7?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse2"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading2"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    To use Hertz 24/7, we require the following documents from
                    you:
                    <br />
                    · A valid driving licence and ID issued in your name (or
                    alternatively a passport plus proof of address)
                    <br />
                    · A credit card, debit card, or PayPal account in your own
                    name
                    <br />
                    · Your mobile phone number and your personal email address
                    <br />
                    During your registration, we carry out the necessary
                    identity checks before confirming your registration.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading3">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse3"
                    aria-expanded="false"
                    aria-controls="flush-collapse3"
                  >
                    <b>
                      How will I be charged when I book a Hertz 24/7 rental?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse3"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading3"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    48 hours before your rental begins, or immediately if your
                    rental starts within 48 hours, we request an authorisation
                    of up to 200% of the original cost on your selected payment
                    method. The booking is only confirmed once the authorisation
                    has been successfully approved. The pre-authorisation is
                    released when the invoice is issued. We deduct the rental
                    fees and refund the remaining amount. If the rental costs
                    exceed the deposit, we will retain the outstanding balance.
                    Please note that any delay in the release of the deposit is
                    caused by your credit or debit card provider.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading4">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse4"
                    aria-expanded="false"
                    aria-controls="flush-collapse4"
                  >
                    <b>How do you unlock the vehicle?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse4"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading4"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    The Hertz 24/7 app is your digital key. To open your
                    vehicle, go to the “Drive” tab during your rental and press
                    the “Unlock” button.
                    <br />
                    Note: You can only unlock the car once your rental period
                    has officially started, the inspection has been completed,
                    and the contract has been signed.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading5">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse5"
                    aria-expanded="false"
                    aria-controls="flush-collapse5"
                  >
                    <b>Who pays for fuel costs?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse5"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading5"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Fuel is not included in our rates. The vehicle is provided
                    with a full tank and must be returned with a full tank.
                    Exceptions may apply for electric vehicles—please check your
                    booking for details.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default CHUkBodyHowitWorks;
